<template>
  <div class="topSearch">
    <div class="searchInput">
      <el-autocomplete
        popper-class="my-autocomplete"
        v-model="top_search"
        placeholder="Search"
        :fetch-suggestions="querySearch"
      >
        <div slot="prefix">
          <img src="@/assets/diapatch/search.png" alt="">
        </div>
        <template slot-scope="{ item }">
          <div class="tips" v-if="item.top == ''">Results from the last 7 days</div>
          <div v-if="top_search.length < 3">
            query too short, at least 3 characters.
          </div>
          <div v-else-if="item.list == 'empty'">
            No results
          </div>
          <div v-else>
            <div>{{
                item.name == 'address' ?
                  'Address' : item.name == 'code' ?
                    'Code' : item.name == 'customer' ?
                      'Costomer' : item.name == 'invoice_number' ?
                        'Invoice' : item.name == 'phone' ? 'Phone' : ''
              }}
            </div>
            <div v-for="(i,v) in item.list" style="display: flex;margin-bottom: 8px">
              <div class="inSearch">
<!--                <img  :src="changetaskImg(i)" alt="">-->
              </div>
              <div @click="openDetailDialog(i)">
                <div class="over address">
                  <span v-html="brightenKeyword(i.address,top_search)"></span>
                </div>
                <div class="over code">
                  <span v-html="brightenKeyword(i.invoice_number,top_search)"></span>
                  |<span v-html="brightenKeyword(i.schedule_name,top_search)"></span>
                </div>
                <div class="over code">
                   <span v-if="i.code != ''">
                    (<span v-html="brightenKeyword(i.code,top_search)"></span>)
                    </span>
                  <span v-html="brightenKeyword(i.recipient_name,top_search)"></span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-autocomplete>
      <!--          <input type="text">-->
    </div>
  </div>

</template>

<script>
import {searchList} from "@/api/dispatch"
import changetaskImg from '@/view/dispatch_test/drag_tree/drag_tree_js/change_tasks_img'


export default {
  name: "top_search_auto",
  data(){
    return{
      top_search:'',
    }
  },
  methods:{
    changetaskImg:{
      changetaskImg
    },
    //搜索内容
    querySearch(queryString, cb) {
      let result = []
      if (queryString.length < 3) {
        result = [{value: "", address: "", top: ''},]
      } else {
        searchList({
          content: queryString
        }).then(res => {
          if (res.code == 200) {
            Object.keys(res.data).forEach(i => {
              if (res.data[i].length != 0) {
                result.push({
                  name: i,
                  list: res.data[i]
                })
              }
            })
            result[0].top = ''
          }
        })
      }
      cb(result);
    },
    brightenKeyword(val,keyword){
      if (keyword.length > 0) {
        val = val + "";
        var reg = new RegExp(keyword,'i') ;
        var isHas = val.match(reg);
        if (isHas) {
          val = val.replace(
            new RegExp(keyword,'i'),
            '<span style="background-color:#ffe72d;">' + isHas[0] + '</span>'
          );
        }
        return val;
      } else {
        return val;
      }
    },
    //搜索后查看详情
    openDetailDialog(i){
      setTimeout(() => {
        this.$emit('openSearchDetial',i)
      },)
    },
  }
}
</script>

<style scoped lang="less">
.topSearch {
  width: 100%;
  height: 32px;
  background: #1F2D42;
  box-shadow: inset 0px -1px 0px 0px #FFFFFF;
  display: flex;

img {
  width: 16px;
  margin: 8px;
}
.searchInput {
  margin-left: 8px;

.el-autocomplete {
/deep/ input {
  color: #CCCCCC !important;
  line-height: 32px;
  height: 32px;
  width: 300px;
  background: none;
  border: none;
}
}

/deep/ .el-input--prefix .el-input__inner {
  padding-left: 40px;
}

/deep/ .el-input__prefix {
  margin-left: 0;
}

}

input:focus-visible {
  border: none;
  outline: none;
}
}

</style>
